export function trimTrailingSlash(str: string): string {
  if (str === '/') {
    return str;
  }
  return str.replace(/[\\/]+$/, '');
}

export function groupBy<TKey extends string | number | symbol, TVal>(
  items: TVal[],
  keyResolver: (item: TVal) => TKey
): Record<TKey, TVal[]> {
  return items.reduce((acc, elem) => {
    const key = keyResolver(elem);
    (acc[key] = acc[key] || []).push(elem);
    return acc;
  }, {} as Record<TKey, TVal[]>);
}
